import React from 'react'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

const PublicLayout = () => {
  return (
   <div className="thrillion-public-layout">
      <ToastContainer
        closeOnClick={true}
        pauseOnHover={true}
        toastStyle={{ color: 'white', backgroundColor: 'black' }}
      />
      <Outlet />
    </div>
  )
}

export default PublicLayout
